export const PHOTOHD = 'photohd'
export const PHOTO_TRANSMISSION_PLAN = 'phototransmission'
export const INSIDERS_CLUB_MEMBERSHIP = 'insidersclub'
export const VIDEOHD = 'videohd'
